
module.exports = function debounce(func, wait, immediate, context, pending) {
  let result;
  let calledOnce = false;
  let timeout = null;
  return function () {
    let ctx = context || this, args = arguments;
    let later = function (cb) {
      result = (cb || func).apply(ctx, args);
    };
    // Tant que la fonction est appelée, on reset le timeout.
    clearTimeout(timeout);
    if (immediate && !calledOnce) {
      calledOnce = true
      result = func.apply(ctx, args);
    } else {
      timeout = setTimeout(later, wait);
      if (pending) return pending.apply(ctx, args);
    }
    return result;
  };
}
